import React from "react";
import { connect } from "react-redux";
import { Styles } from "../styles";

import {
  CustomText,
  InputAutoComplete,
  InputDate,
  Select,
} from "../../../components";
import { Fonts, Spacing, Themes } from "../../../config";
import { Grid } from "@material-ui/core";
import {
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Search,
} from "@material-ui/icons";
import { FormHolder } from "../../../FormConfig";

import fonts from "../../../config/fonts";
const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1; // Os meses em JavaScript são indexados de 0 a 11

const begin = new Date(year, month - 1, 1);
const end = now;
function Filters({ isFetching, listInputs, onSubmit, onClear }) {
  const [show, setShow] = React.useState(true);
  const [ref, setRef] = React.useState(null);
  const [initDate, setInitDate] = React.useState(begin);
  const options = [
    { value: -1, label: "Todos" },
    { value: 1, label: "Sim" },
    { value: 0, label: "Não" },
    { value: 2, label: "Indefinido" },
  ];
  return (
    <Styles.Content>
      <Styles.HeaderCard>
        <CustomText fontFamily={Fonts.bold} fontSize={1.75}>
          PESQUISAR HISTÓRICO DE CONSULTAS
        </CustomText>
        <Styles.Hide onClick={() => setShow(!show)}>
          {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Styles.Hide>
      </Styles.HeaderCard>
      <Styles.Line></Styles.Line>
      {show && (
        <>
          <FormHolder formRef={setRef} onSubmit={onSubmit}>
            <Grid container spacing={1} style={{ alignItems: "flex-end" }}>
              <Grid item xs={12} md={4}>
                <InputAutoComplete
                  color={1}
                  placeholder="Todos"
                  name="cpfOrCnpj"
                  inputLabel="CPF/CNPJ"
                  options={listInputs?.length > 0 ? listInputs : []}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Select
                  color={1}
                  placeholder="Todos"
                  name="signalCreditRelease"
                  inputLabel="POSSIBILIDADE DE LIBERAR CRÉDITO?"
                  options={options}
                  defaultValue={-1}
                  value={-1}
                />
              </Grid>
              <Grid container item spacing={1} xs={12} md={5}>
                <Grid
                  container
                  item
                  xs={12}
                  style={{ marginBottom: Spacing(-1) }}
                >
                  <CustomText
                    textColor={Themes.Light.palette.background.associated}
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                  >
                    PERÍODO
                  </CustomText>
                </Grid>

                <Grid item xs={5}>
                  <InputDate
                    defaultValue={begin}
                    color={1}
                    name="begin"
                    nextInput="end"
                    placeholder="dd/mm/yyyy"
                    onChange={(data, value) => {
                      if (
                        ref?.getFieldValue("end") &&
                        ref?.getFieldValue("end") < value
                      ) {
                        setInitDate(value);
                        var novaData = new Date(value);
                        novaData.setDate(value.getDate() + 1);

                        ref?.setValue("end", novaData);
                      } else {
                        setInitDate(value);
                      }
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ justifyContent: "center", display: "flex" }}
                >
                  <CustomText
                    styles={{ paddingTop: Spacing(1.75) }}
                    fontSize={1.75}
                    fontFamily={fonts.medium}
                  >
                    até
                  </CustomText>
                </Grid>
                <Grid item xs={5}>
                  <InputDate
                    defaultValue={end}
                    color={1}
                    minDate={initDate}
                    name="end"
                    placeholder="dd/mm/yyyy"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Styles.FormButtons>
              <Styles.FormButtonOutlined
                startIcon={<Delete />}
                fullWidth={false}
                type="clear"
                onClick={() => {
                  ref?.clearAllValues(true);
                  onClear();
                }}
              >
                Limpar
              </Styles.FormButtonOutlined>
              <Styles.FormButton
                startIcon={<Search />}
                fullWidth={false}
                type="submit"
              >
                Pesquisar
              </Styles.FormButton>
            </Styles.FormButtons>
          </FormHolder>
        </>
      )}
    </Styles.Content>
  );
}

function mapStateToProps(redux) {
  const { isFetching } = redux.registerAndQuery;
  return { isFetching };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Filters));
